import newAccount from './newAccount.js';
import UserCookieBaseService from './userCookieBaseService.js';
import {storage} from '@nuskin/ns-util';

/**
 *
 * UserCookieService
 *
 * @namespace UserCookieService
 * @returns {object} UserCookieBaseService
 */
newAccount.UserCookieService = function(){
    "use strict";
    return new UserCookieBaseService(storage.metadata.USER_COOKIE_BASE);
}();

export default newAccount.UserCookieService;
